export const hGClose = (e, ref, instance, visibleProps) => {
  const node = ref
  if (!node.contains(e.target)) {
    instance.setState({
      [visibleProps]: false
    })
  }
}